import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useParams} from "react-router-dom";
import {useSubscriptionItem} from "../hooks/useSubscriptionItem.ts";
import {SubscriptionItem} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const params = useParams();
    const subscriptionId = params.id || params.subscriptionId || '';

    const {
        createRecord,
    } = useSubscriptionItem(subscriptionId);

    return (
        <FormDrawer
            record={{
                id: '',
                subscriptionId: subscriptionId,
                priceId: '',
                quantity: 1,
            } as SubscriptionItem}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
